export function initPostCardExcerpts() {
  const postCards = document.querySelectorAll(".post-card");

  const cards: {
    excerptContainer: HTMLDivElement;
    excerptText: HTMLParagraphElement;
    originalText: string;
  }[] = [];

  postCards.forEach((card) => {
    const excerptContainer = card.querySelector(
      ".text-content",
    ) as HTMLDivElement | null;
    const excerptText = excerptContainer?.querySelector(
      "p",
    ) as HTMLParagraphElement | null;

    if (!excerptContainer || !excerptText) return;

    cards.push({
      excerptContainer,
      excerptText,
      originalText: excerptText.textContent || "",
    });
  });

  function truncateCard({
    excerptContainer,
    excerptText,
    originalText,
  }: (typeof cards)[number]) {
    excerptText.textContent = originalText;

    if (excerptText.scrollHeight <= excerptContainer.clientHeight) return;

    let low = 0;
    let high = originalText.length;
    let bestFit = "";

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const testText = originalText.slice(0, mid) + "...";
      excerptText.textContent = testText;

      if (excerptText.scrollHeight <= excerptContainer.clientHeight) {
        bestFit = testText;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    excerptText.textContent = bestFit || originalText.slice(0, 50) + "...";
  }

  function runTruncation() {
    cards.forEach(truncateCard);
  }

  runTruncation();

  let resizeTimeout: ReturnType<typeof setTimeout>;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(runTruncation, 150);
  });
}
